import axios from "axios";

const REQ_TIMEOUT = 25 * 1000;

export const ApiPublicInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: REQ_TIMEOUT,
});

ApiPublicInstance.interceptors.response.use(
  (response) => response.data.data,
  (error) => error
);
